import { Tag } from '@cencosud-cencommerce/paris-uikit';

export const CardExpired = (): JSX.Element => {
  return <Tag>Tarjeta Expirada</Tag>;
};
